import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Pipe, PipeTransform } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize, first } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { AngularEditorConfig } from "@kolkov/angular-editor";

import { FormIsValidDTO } from "src/app/parametrage/core/model/form-is-valid-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { ExecuterAllTask } from "src/app/mon-portefeuille/core/model/executer-all-task";
import { TaskService } from "src/app/mon-portefeuille/core/service/task.service";
import { Client } from 'src/app/parametrage/core/model/client';
import { Fournisseur } from 'src/app/parametrage/core/model/fournisseur';
import { ClientService } from 'src/app/parametrage/core/service/client.service';
import { FournisseurService } from 'src/app/parametrage/core/service/fournisseur.service';
import { AddClientComponent } from '../../modal/entreprise/add-client/add-client.component';
import { EditClientComponent } from '../../modal/entreprise/edit-client/edit-client.component';
import { AddFournisseurComponent } from '../../modal/entreprise/add-fournisseur/add-fournisseur.component';
import { EditFournisseurComponent } from '../../modal/entreprise/edit-fournisseur/edit-fournisseur.component';

@Component({
  selector: 'app-form-complement-dossier-entreprise',
  templateUrl: './form-complement-dossier-entreprise.component.html',
  styleUrls: ['./form-complement-dossier-entreprise.component.scss']
})
export class FormComplementDossierEntrepriseComponent implements OnInit {

  requestId: string;
  taskId: string;

  checkFormDTO: FormIsValidDTO;
  command: ExecuterAllTask = new ExecuterAllTask();

  pressButton: Boolean = false;
  form: FormGroup;

  name = "Angular 6";
  htmlContent = "";

  clients:Client[];
  fournisseurs:Fournisseur[];

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "8rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    toolbarHiddenButtons: [["bold"]],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
    private _formulaireService: FormulaireService,
    private _taskService: TaskService,
    private _clientService: ClientService,
    private _fournisseurService: FournisseurService
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.taskId = params["taskId"];
      this.checkIfFormIsValid(this.taskId);
      this.getClientsByRequestId(this.requestId);
      this.getFournisseursByRequestId(this.requestId);
    });
  }

  checkIfFormIsValid(taskId) {
    this._formulaireService.checkForm(taskId).subscribe(
      (data) => {
        this.checkFormDTO = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  
  
  /**
   * CLIENT
   */
  getClientsByRequestId(requestId)
  {
      this._clientService.getClientsByRequestId(requestId)
      .subscribe(
            data => {
              debugger
              this.clients =  data;
            },
            error => {
              console.log(error);
            });
  }

  AddClient()
  {
    const modalRef = this.modalService.open(AddClientComponent,
      {size: 'lg', backdrop: 'static',centered:true});
      
    modalRef.componentInstance.requestId = this.requestId;

    modalRef.result.then((data) => {
      // on close
      this.getClientsByRequestId(this.requestId);
      }, (reason) => {
      // on dismiss
      });
  }

  deleteClient(clientId)
  {
    this._clientService.delete(clientId)
    .pipe(first())
            .subscribe(
                data => {
                  this.getClientsByRequestId(this.requestId);
                },
                error => {
                  console.log(error);
            });
  }
  
  EditClient(clientId)
  {
    const modalRef = this.modalService.open(EditClientComponent,{centered:true});
    modalRef.componentInstance.clientId = clientId;

    modalRef.result.then((data) => {
      // on close
      this.getClientsByRequestId(this.requestId);
      }, (reason) => {
      // on dismiss
      });
  }


  /**
   * FOURNISSEUR
   */
  getFournisseursByRequestId(requestId)
  {
      this._fournisseurService.getFournisseursByRequestId(requestId)
      .subscribe(
            data => {
              this.fournisseurs =  data;
            },
            error => {
              console.log(error);
            });
  }

  AddFournisseur()
  {
    const modalRef = this.modalService.open(AddFournisseurComponent,
      {size: 'lg', backdrop: 'static',centered:true});
      
    modalRef.componentInstance.requestId = this.requestId;

    modalRef.result.then((data) => {
      // on close
      this.getFournisseursByRequestId(this.requestId);
      }, (reason) => {
      // on dismiss
      });
  }

  deleteFournisseur(fournisseurId)
  {
    this._fournisseurService.deleteFournisseurById(fournisseurId)
    .pipe(first())
            .subscribe(
                data => {
                  this.getFournisseursByRequestId(this.requestId);
                },
                error => {
                  console.log(error);
            });
  }
  
  EditFournisseur(fournisseurId)
  {
    const modalRef = this.modalService.open(EditFournisseurComponent,{centered:true});
    modalRef.componentInstance.fournisseurId = fournisseurId;

    modalRef.result.then((data) => {
      // on close
      this.getFournisseursByRequestId(this.requestId);
      }, (reason) => {
      // on dismiss
      });
  }



  executeTask(): void {
    this.command.taskId = this.taskId;
    this.command.requestId = this.requestId;
    this.command.messageText = this.htmlContent;

    this.pressButton = true;

    this.spinner.show();
    this._taskService
      .executerAllTask(this.command)
      .pipe(
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
  }

}
